import type { VariantType } from "../types/enum.js";

export const VARIANT_ACCENT_OKLCH = {
	default: { light: "oklch(0.6204 0.195 253.83)", dark: "oklch(0.6204 0.195 253.83)" },
	coral: { light: "oklch(0.6469 0.2078 22.73)", dark: "oklch(0.6469 0.2078 22.73)" },
	green: { light: "oklch(0.7329 0.1935 150.81)", dark: "oklch(0.7329 0.1935 150.81)" },
	sky: { light: "oklch(0.7206 0.191 231.6)", dark: "oklch(0.5507 0.2159 231.6)" },
} as const satisfies Record<VariantType, { light: string; dark: string }>;

export const VARIANT_ACCENT_HEX = {
	default: { light: "#3B82F6", dark: "#60A5FA" },
	coral: { light: "#F97316", dark: "#FB923C" },
	green: { light: "#22C55E", dark: "#4ADE80" },
	sky: { light: "#38BDF8", dark: "#0EA5E9" },
} as const satisfies Record<VariantType, { light: string; dark: string }>;
